<template>
  <kt-panel>
    <div class="accordion accordion-toggle-arrow" id="accounting-filter">
      <div class="card" style="overflow: inherit">
        <div class="card-header bg-transparent" id="headingOne">
          <div class="card-title collapsed" data-toggle="collapse"
            data-target="#filterForm"
            aria-controls="filterForm">
            {{ $t("label.search") }}
          </div>
        </div>
        <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#accounting-filter">
          <div class="card-body">
            <form @submit.prevent="action($event, query)" id="transaction-filter-form">
              <kt-form-selection>
                <kt-form-row>
                  <kt-col v-if="$can('read', 'accounting')" xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="account_select">
                        {{ $t("accounting.label.select_account") }}
                      </kt-form-label>
                        <select
                          class="form-control"
                          v-model="selectedAccount"
                          name="account_select"
                          id="account_select"
                          @change="setSelectedAccount"
                        >
                        <option value="">{{ $t('selectpicker.nothing_selected') }}</option>
                        <option v-for="account in accounts" :key="account.id" :value="account.id">
                            {{ account.account_number }} - {{ account.bank_name }} - {{ account.company }}
                          </option>
                        </select>
                    </kt-form-group>
                  </kt-col>
                  <kt-col v-if="$can('read', 'accounting')" xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="filter_type">
                        {{ $t('accounting.label.transaction_type') }}
                      </kt-form-label>
                      <select class="form-control" v-model="selectedType" name="filter_type" id="filter_type" @change="setSelectedType">
                        <!-- Default "Nothing Selected" option -->
                        <option value="">{{ $t('selectpicker.nothing_selected') }}</option>
                        <option
                          v-for="(type, index) in transactionTypes"
                          :key="index"
                          :value="type.code"
                        >
                          {{ type.label }}
                        </option>
                      </select>
                    </kt-form-group>
                  </kt-col>                  
                  
                  <kt-col v-if="$can('read', 'accounting')" xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="transaction_id">
                        {{ $t('accounting.label.transaction_id') }}
                      </kt-form-label>
                      <kt-form-control ref="transaction_id" dir="ltr" name="transaction_id" id="transaction_id" v-model="query.transaction_id"/>
                    </kt-form-group>
                  </kt-col>
                  <kt-col v-if="$can('read', 'accounting')" xs="12" sm="6" md="6">
                    <kt-form-group>
                      <kt-form-label for="account_number">
                        {{ $t('accounting.account_number') }}
                      </kt-form-label>
                      <kt-form-control ref="account_number" dir="ltr" name="account_number" id="account_number" v-model="query.account_number"/>
                    </kt-form-group>
                  </kt-col>
                  <kt-col v-if="$can('read', 'accounting')" xs="12" sm="6" md="6">
                    <kt-form-group>
                      <kt-form-label for="sheba_number">
                        {{ $t('accounting.iban_number') }}
                      </kt-form-label>
                      <kt-form-control ref="sheba_number" dir="ltr" name="sheba_number" id="sheba_number" v-model="query.sheba_number"/>
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="from_date">
                        {{ $t('label.from_date') }}
                      </kt-form-label>
                      <button id="reset_from_date"
                              @click="clearFromDate"
                              type="button"
                              class="btn btn-label-danger trash-btn"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <datePicker
                          format="YYYY-MM-DD HH:mm:ss"
                          display-format="dddd jDD jMMMM jYYYY HH:mm"
                          input-class="form-control"
                          id="from_date"
                          name="from_date"
                          v-model="query.from_date"
                          type="datetime" />
                        </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="to_date">
                        {{ $t('label.to_date') }}
                      </kt-form-label>
                      <button id="reset_to_date"
                              @click="clearToDate"
                              type="button"
                              class="btn btn-label-danger trash-btn"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <datePicker
                          format="YYYY-MM-DD HH:mm:ss"
                          display-format="dddd jDD jMMMM jYYYY HH:mm"
                          input-class="form-control"
                          id="to_date"
                          name="to_date"
                          v-model="query.to_date"
                          type="datetime"
                      />
                    </kt-form-group>
                  </kt-col>
                </kt-form-row>
              </kt-form-selection>
              <kt-form-section>
                <kt-row>
                  <kt-col xs="12" sm="6" md="6">
                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                    <button id="transaction_excel_export" type="button" class="btn btn-success btn-wide mx-4" @click="exportToExcel">{{ $t('label.excel_export') }}</button>
                  </kt-col>
                </kt-row>
              </kt-form-section>
            </form>
          </div>
        </div>
      </div>
    </div>
  </kt-panel>
</template>

<script>
import {
  TRANSACTION_TYPES,
  TRANSACTION_TYPES_STR,
  TRANSACTION_TYPES_ACCOUNTING
} from "@/constants/accountingTransactionType";
import { accountingService, starShopAccountingService } from "@/common/api.service";
import { KTApp } from "@/plugins/core/app";
import toastr from "toastr";
import $ from 'jquery';

export default {
  props: {
    action: {
      default: {},
      required: true,
    },
    query: {
      required: true,
      default: {}
    },
    type: {
      type: String,
      required: true,
      default: "pf"
    },
  },
  data() {
    return {
      accounts: [],
      selectedAccount: '', 
      selectedType: '',
      transactionTypes: this.getTransactionTypesWithLabels(),
      TRANSACTION_TYPES_ACCOUNTING, 
      TRANSACTION_TYPES,
      TRANSACTION_TYPES_STR,
      errors: {},
    };
  },
  methods: {
    getTransactionTypesWithLabels() {
      const typesWithLabels = [];

      for (const [key, code] of Object.entries(TRANSACTION_TYPES)) {
        typesWithLabels.push({
          code: code,
          label: TRANSACTION_TYPES_STR[key] || key 
        });
      }

      return typesWithLabels;
    },
    setSelectedType() {
      this.query.type = this.selectedType
    },
    setSelectedAccount() {
      this.query.account_id = this.selectedAccount
    },
    selectType(typeCode) {
      this.selectedType = typeCode;
      this.query.type = this.selectedType; 
    },
    clearFromDate() {
      if (this.query.from_date) {
        this.query.from_date = null;
      }
    },
    clearToDate() {
      if (this.query.to_date) {
        this.query.to_date = null;
      }
    },

    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };
      return toastr;
    },
    fetchAccounts() {
      const service = this.type === "starshop" ? starShopAccountingService : accountingService;
      service.getAllAccounts().then((response) => {
        this.accounts = response.data.data;
      });
    },
    exportToExcel() {
      let btn = $("#transaction_excel_export");
      KTApp.progress(btn);
      const payload = {
        query: {
          type: this.query.type,
          sheba_number: this.query.sheba_number,
          account_number: this.query.account_number,
          account_id: this.selectedAccount,
          transaction_id: this.query.transaction_id,
          from_date: this.query.from_date,
          to_date: this.query.to_date
        }
      };

      const service = this.type === "starshop" ? starShopAccountingService : accountingService;
      service.createExcelRequest(payload, { responseType: "blob" }).then((response) => {
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          if (
            !response.data ||
            contentType !==
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            KTApp.unprogress(btn);
            return;
          }

          const blob = new Blob([response.data], { type: contentType });
          const fileURL = window.URL.createObjectURL(blob);
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `accounting_transactions_from_${this.query.from_date}_to_${this.query.to_date}.xlsx`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        })
        .finally(() => {
          KTApp.unprogress(btn);
        });
    },

  },
      created() {
        this.fetchAccounts();
    }
};
</script>

<style scoped>

</style>
